const STATUS = {
    DRAFT: "draft",
    PUBLISHED: "published",
    ARCHIVED: "archived",
};

export default STATUS;



// WEBPACK FOOTER //
// ./src/util/STATUS.js